function initFitvids() {
    if ( $('.fitvids').length > 0) {
        $('.fitvids').fitVids();
    }
}

function initYoutubeVideos() {
    var youtubeVideos = $(".youtube");

    youtubeVideos.each(function (index, elem) {
        // on récupère la vignette
        var source = '';

        if ($(this).data('poster')) {
            source = $(this).data('poster');
        } else {
            source = "https://img.youtube.com/vi/" + $(this).data('embed') + "/sddefault.jpg";
        }

        // Chargement asynchrone des vignettes
        var image = new Image();
        image.src = source;

        image.addEventListener("load", function () {
            $(elem).append(image);
        });

        $(this).on('click', function (elem) {
            if (!$(this).hasClass('playing')) {
                // Reset de toutes les vidéos en cours de lecture
                youtubeVideos.removeClass('loading playing');
                $(this).addClass('loading');

                var iframe = document.createElement("iframe");
                var container = $(this).find('.youtube__container');

                iframe.setAttribute("frameborder", "0");
                iframe.setAttribute("allowfullscreen", "");
                iframe.setAttribute("src", "https://www.youtube.com/embed/" + this.dataset.embed + "?autoplay=1&color=white&enablejsapi=1&controls=2&iv_load_policy=3&listType=user_uploads&modestbranding=1&rel=0&showinfo=0");

                setTimeout(function () {
                    $('.youtube__container').empty();
                    container.append(iframe);
                    container.parent().addClass('playing');
                }, 400);
            }
        });
    });
}